import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  Stack,
  OutlinedInput,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  ListItemText,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import {
  SPL_PromoCouponDetail_GetRow,
  SPL_PromoCouponHead_Detail_Update,
  SPL_PromoCouponDetail_Delete,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";

const CouponDetail = ({ open, onClose, selectedRow, onLoad }) => {
  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const userCd = useSelector((state) => state.login.value);
  const [errors, setErrors] = useState({});
  const [gridData, setGridData] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedRedeemRowIds, setSelectedRedeemRowIds] = useState([]);
  const getEmptyForm = () => ({
    promotionId: "0",
    locations: LocWithRights[0] ? [LocWithRights[0].Uid] : [],
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    purchase: "",
    redemptionLimit: "",
    discount: "",
    active: 0,
    multipleCoupon: 0,
    validFrom: moment().format("YYYY-MM-DD"),
    validTo: moment().format("YYYY-MM-DD"),
  });

  const [form, setForm] = useState(getEmptyForm());

  useEffect(() => {
    // Call getRow API and populate form regardless of ID
    if (open) {
      if (open && selectedRow) {
        console.log("PROMOID:", selectedRow.A_PromotionID);

        setForm({
          promotionId: selectedRow.A_PromotionID,
          locations: [selectedRow.Location],
          fromDate: moment(selectedRow.A_FromDate),
          toDate: moment(selectedRow.A_ToDate),
          purchase: selectedRow.A_PurchaseAmount,
          redemptionLimit: selectedRow.A_RedemptionLimit,
          discount: selectedRow.A_DiscountPercent,
          active: selectedRow.A_IsActive ? 1 : 0,
          multipleCoupon: selectedRow.A_MultipleCoupon ? 1 : 0,
          validFrom: moment(selectedRow.A_CouponValidFrom),
          validTo: moment(selectedRow.A_CouponValideTo),
        });

        // ✅ Always call the GetRow API — even for ID 0
        SPL_PromoCouponDetail_GetRow({
          B_PromotionID: selectedRow.A_PromotionID ?? 0,
        }).then((res) => {
          const records = res?.data || {};
          setGridData(records);
          const selectedIds = records.detail
            .filter((row) => row.isSelected)
            .map((row) => row.B_MainGrp);
          setSelectedRowIds(selectedIds);
          const selectedRedeemIds = records.redeem
            .filter((row) => row.isSelected)
            .map((row) => row.B_MainGrp);
          setSelectedRedeemRowIds(selectedRedeemIds);
        });
      } else {
        handleNew();
      }
    }
  }, [open, selectedRow]);

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    setErrors({ ...errors, [field]: null });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.fromDate) newErrors.fromDate = "From date is required";
    if (!form.toDate) newErrors.toDate = "To date is required";
    if (!form.validFrom) newErrors.validFrom = "Valid from is required";
    if (!form.validTo) newErrors.validTo = "Valid to is required";
    if (!form.purchase || isNaN(form.purchase))
      newErrors.purchase = "Enter a valid purchase amount";
    if (!form.redemptionLimit || isNaN(form.redemptionLimit))
      newErrors.redemptionLimit = "Enter a valid redemption limit";
    if (!form.discount || isNaN(form.discount))
      newErrors.discount = "Enter a valid discount %";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNew = () => {
    setForm(getEmptyForm());
    setSelectedRowIds([]);
    setSelectedRedeemRowIds([]);
    setGridData([]);
    setErrors({});
    SPL_PromoCouponDetail_GetRow({
      B_PromotionID: "0",
    }).then((res) => {
      setGridData(res?.data || {});
    });
  };

  const handleSave = async () => {
    if (!validate()) return;
    const Items = gridData.detail
      .filter(
        (item) => selectedRowIds.includes(item.B_MainGrp) || item.isSelected
      )
      .map((item) => ({ B_MainGrp: item.B_MainGrp }));

    const Redeem = gridData.redeem
      .filter(
        (item) =>
          selectedRedeemRowIds.includes(item.B_MainGrp) || item.isSelected
      )
      .map((item) => ({ B_MainGrp: item.B_MainGrp }));
    const payload = {
      A_PromotionID: form.promotionId,
      A_Loc: form.locations.toString(),
      A_FromDate: moment(form.fromDate).format("MM/DD/YYYY"),
      A_ToDate: moment(form.toDate).format("MM/DD/YYYY"),
      A_PurchaseAmount: parseFloat(form.purchase),
      A_RedemptionLimit: parseFloat(form.redemptionLimit),
      A_DiscountPercent: parseFloat(form.discount),
      A_IsActive: form.active,
      A_MultipleCoupon: form.multipleCoupon,
      A_CouponValidFrom: moment(form.validFrom).format("MM/DD/YYYY"),
      A_CouponValidTo: moment(form.validTo).format("MM/DD/YYYY"),
      A_UserCd: userCd.UserID,
      Items: Items,
      Redemption: Redeem,
    };

    const res = await SPL_PromoCouponHead_Detail_Update(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (res?.data?.ResultSet?.[0]?.A_PromotionID) {
      fAlertToast(
        "SUCCESS",
        "Saved Successfully",
        res?.data?.ResultSet?.[0]?.A_PromotionID
      );
      onLoad();
    }
  };

  // const handleDelete = () => {
  //   if (!form.promotionId) return;

  //   confirmAlert({
  //     title: "Delete",
  //     message: "Are you sure you want to delete this entry?",
  //     buttons: [
  //       {
  //         className: "alertBtn",
  //         label: "Yes",
  //         onClick: async () => {
  //           try {
  //             await SPL_PromoCouponDetail_Delete({
  //               PromotionID: form.promotionId,
  //             });
  //             fAlertToast("Deleted Successfully");
  //             onClose();
  //           } catch (err) {
  //             console.error("Delete Error:", err);
  //             alert("Failed to Delete.");
  //           }
  //         },
  //       },
  //       {
  //         className: "alertBtn",
  //         label: "No",
  //         onClick: () => {}, // No action
  //       },
  //     ],
  //   });
  // };
  const handleClose = () => {
    setErrors({});
    setForm(getEmptyForm());
    setSelectedRowIds([]);
    setSelectedRedeemRowIds([]);

    onClose();
  };
  const columns = [{ field: "MainGrpName", headerName: "Name", width: 200 }];
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Coupon Details
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box>
          <Grid container spacing={1} rowSpacing={1}>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                label="Promotion ID"
                value={form.promotionId}
                fullWidth
                size="small"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl size="small" fullWidth>
                <InputLabel id="location-select-label">Location</InputLabel>
                <Select
                  labelId="location-select-label"
                  id="location-select"
                  multiple
                  value={form.locations}
                  onChange={(event) => {
                    const { value } = event.target;
                    if (value.includes("all")) {
                      setForm((prev) => ({
                        ...prev,
                        locations:
                          form.locations.length === LocWithRights.length
                            ? []
                            : LocWithRights.map((loc) => loc.Uid),
                      }));
                      return;
                    }
                    setForm((prev) => ({
                      ...prev,
                      locations: value,
                    }));
                  }}
                  label="Location"
                  displayEmpty
                  // inputRef={locationSelectRef}
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "20px",
                        overflowY: "auto",
                      }}
                    >
                      {selected.map((value) => (
                        <Box
                          key={value}
                          sx={{
                            whiteSpace: "nowrap",
                            padding: "2px 4px",
                            backgroundColor: "#f0f0f0",
                            borderRadius: "4px",
                            margin: "2px 0",
                          }}
                        >
                          {LocWithRights.find((loc) => loc.Uid === value)
                            ?.Name1 || value}
                        </Box>
                      ))}
                    </Box>
                  )}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox
                      checked={form.locations.length === LocWithRights.length}
                      indeterminate={
                        form.locations.length > 0 &&
                        form.locations.length < LocWithRights.length
                      }
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {LocWithRights.map((locationItem) => (
                    <MenuItem key={locationItem.Uid} value={locationItem.Uid}>
                      <Checkbox
                        checked={form.locations.includes(locationItem.Uid)}
                      />
                      <ListItemText primary={locationItem.Name1} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <DatePicker
                label="From Date"
                value={form.fromDate}
                onChange={(date) => handleChange("fromDate", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!errors.fromDate}
                    helperText={errors.fromDate}
                    fullWidth
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <DatePicker
                label="To Date"
                value={form.toDate}
                onChange={(date) => handleChange("toDate", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!errors.toDate}
                    helperText={errors.toDate}
                    fullWidth
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <TextField
                label="Purchase Amount"
                value={form.purchase}
                onChange={(e) => handleChange("purchase", e.target.value)}
                error={!!errors.purchase}
                helperText={errors.purchase}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <TextField
                label="Redemption Limit"
                value={form.redemptionLimit}
                onChange={(e) =>
                  handleChange("redemptionLimit", e.target.value)
                }
                error={!!errors.redemptionLimit}
                helperText={errors.redemptionLimit}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <TextField
                label="Discount %"
                value={form.discount}
                onChange={(e) => handleChange("discount", e.target.value)}
                error={!!errors.discount}
                helperText={errors.discount}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <DatePicker
                label="Coupon Valid From"
                value={form.validFrom}
                onChange={(date) => handleChange("validFrom", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!errors.validFrom}
                    helperText={errors.validFrom}
                    fullWidth
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <DatePicker
                label="Coupon Valid To"
                value={form.validTo}
                onChange={(date) => handleChange("validTo", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!errors.validTo}
                    helperText={errors.validTo}
                    fullWidth
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.active === 1}
                    onChange={(e) =>
                      handleChange("active", e.target.checked ? 1 : 0)
                    }
                  />
                }
                label="Active"
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.multipleCoupon === 1}
                    onChange={(e) =>
                      handleChange("multipleCoupon", e.target.checked ? 1 : 0)
                    }
                  />
                }
                label="Multiple Coupon"
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", width: "100%", gap: 2, mt: 3 }}>
            {/* Left: Purchase Limit */}
            <Box sx={{ flex: 1, height: 300, mr: 2 }}>
              <Typography variant="h6" gutterBottom>
                Purchase Limit
              </Typography>
              <DataGrid
                rows={Array.isArray(gridData.detail) ? gridData.detail : []}
                columns={columns} // You can use a subset or different set here
                headerHeight={40}
                rowHeight={30}
                getRowId={(row) => row.B_MainGrp}
                checkboxSelection
                selectionModel={selectedRowIds}
                disableRowSelectionOnClick
                hideFooter
                onSelectionModelChange={(newSelectionModel) => {
                  setSelectedRowIds(newSelectionModel);
                }}
              />
            </Box>

            {/* Right: Redemption */}
            <Box sx={{ flex: 1, height: 300 }}>
              <Typography variant="h6" gutterBottom>
                Redemption
              </Typography>
              <DataGrid
                rows={Array.isArray(gridData.redeem) ? gridData.redeem : []}
                columns={columns}
                headerHeight={40}
                rowHeight={30}
                getRowId={(row) => row.B_MainGrp}
                checkboxSelection
                selectionModel={selectedRedeemRowIds}
                disableRowSelectionOnClick
                hideFooter
                onSelectionModelChange={(newSelectionModel) => {
                  setSelectedRedeemRowIds(newSelectionModel);
                }}
              />
            </Box>
          </Box>

          <Box
            mt={8}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Stack direction="row" spacing={2}>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Save
              </Button>
              {/* <Button variant="outlined" onClick={handleNew}>
                New
              </Button> */}
              {/* <Button variant="outlined" color="error" onClick={handleDelete}>
                Delete
              </Button> */}
            </Stack>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CouponDetail;
